
import DashboardLayout from '../pages/Dashboard/Layout/DashboardLayout'
import Dashboard from '../pages/Dashboard/Dashboard'

const Macro = () => import('../pages/Macro/Macro')

import groupRouting from './groupRouting'

const mainPages = {
  path: '/',
  component: DashboardLayout,
  name: 'mainPages',
  icon: 'bookmarks',
  title: 'Principal',

  excludedRoles: ['EXCLI', 'IDEAL'],

  children: [
    {
      path: '/dashboard',
      name: 'Dashboard',
      title: 'Dashboard',
      component: Dashboard,
      redirect: groupRouting,
    },
    {
      path: '/macro',
      name: 'Macro',
      title: 'Macro',
      component: Macro,
      excludedRoles: [ 'IDEAL' ],
      meta: {
        ifUserCan: {
          report_by_process: 'Sinister/sinister'
        }
      },
    }
  ],
}

export default mainPages



// WEBPACK FOOTER //
// ./src/router/mainRoutes.js